import { FC, useMemo } from "react";

import { IIconBandSetting, IBandIcalParams } from "Bands/types";
import { FormBuilder } from "shared/components";
import { IAPIState, IFormButtons } from "shared/types";
import { copy } from "shared/assets";

import { getFields } from "./formData";

const iCalCopy = copy.calendar.iCalExport;

interface Props {
  eventTypes: IIconBandSetting[];
  apiStatus?: IAPIState;
  hasError?: boolean;
  defaultValues?: Record<string, any>;
  onCancel: () => void;
  handleSubmit: (data: IBandIcalParams) => void;
}

export const ExportICalForm: FC<Props> = ({
  eventTypes,
  apiStatus,
  hasError,
  defaultValues,
  onCancel,
  handleSubmit,
}) => {
  const fields = useMemo(
    () =>
      getFields({
        eventTypes,
      }),
    [eventTypes]
  );

  const buttons = useMemo(
    (): IFormButtons => ({
      primary: {
        "data-testid": "save_ical_export",
        children: iCalCopy.buttons.save,
        size: "m",
      },
      secondary: {
        onClick: onCancel,
        size: "m",
      },
    }),
    [onCancel]
  );

  return (
    <FormBuilder
      submitMode="isDirty"
      fields={fields}
      isSubmitting={apiStatus === IAPIState.pending}
      apiErrorMessage={hasError}
      onSubmit={handleSubmit}
      defaultValues={defaultValues}
      buttons={buttons}
      dataTestId="export_ical_form"
    />
  );
};
